
import React from 'react';

export const BackgroundEffects = () => (
  <>
    <div className="synthwave-grid"></div>
  </>
);

export const TypingIndicator = () => (
  <div className="flex space-x-2">
    <div className="w-3 h-3 rounded-full bg-cyan-100 animate-synthwave-typing"></div>
    <div className="w-3 h-3 rounded-full bg-cyan-100 animate-synthwave-typing" style={{animationDelay: '0.2s'}}></div>
    <div className="w-3 h-3 rounded-full bg-cyan-100 animate-synthwave-typing" style={{animationDelay: '0.4s'}}></div>
  </div>
); 